import createIcon from '@/lib/create-icon'

const UserIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      d='M19 21C19 20.0807 18.8189 19.1705 18.4672 18.3212C18.1154 17.4719 17.5998 16.7003 16.9497 16.0503C16.2997 15.4002 15.5281 14.8846 14.6788 14.5328C13.8295 14.1811 12.9193 14 12 14C11.0807 14 10.1705 14.1811 9.32122 14.5328C8.47194 14.8846 7.70026 15.4002 7.05025 16.0503C6.40024 16.7003 5.88463 17.4719 5.53284 18.3212C5.18106 19.1705 5 20.0807 5 21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'UserIcon'
)

export default UserIcon
